// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root___mPeM","left":"InfoRow_left__2jn9A"};